const BrowseRooms = () => {
    return (
        <div className="container h-screen flex items-center justify-center">
           
        </div>
    );
};

export default BrowseRooms